import {
  FIRST_COLUMN_PADDING_WITHOUT_CHECKBOX,
  FIRST_COLUMN_PADDING_WITH_CHECKBOX,
} from '@components/ListV2/components/table/virtualizedTable.styles';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import useMoney from '../../../hooks/useMoney';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import { OrderListType, OrderListWithBaseItem } from '../order.types';

interface OrderListProps {
  item: OrderListWithBaseItem;
  hasCheckBox?: boolean;
}

const OrderListParent = ({ item, hasCheckBox }: OrderListProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  return (
    <Box
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'flex',
        padding: hasCheckBox
          ? FIRST_COLUMN_PADDING_WITH_CHECKBOX
          : FIRST_COLUMN_PADDING_WITHOUT_CHECKBOX,
      }}
    >
      <Typography>{item.baseCode}</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          columnGap: '24px',
          position: 'sticky',
          right: 12,
        }}
      >
        <Typography color="textSecondary">
          {translate(LangEnum.GLOBAL_ITEM, {
            quantity: (item as OrderListType).parentTotalItems,
          })}
        </Typography>
        <Typography color="textSecondary">
          {translate(LangEnum.GLOBAL_PIECE, {
            quantity: (item as OrderListType).parentTotalPieces,
          })}
        </Typography>
        <Typography color="textSecondary">
          {formatMoney((item as OrderListType).parentSubTotal)}
        </Typography>
      </Box>
    </Box>
  );
};

export default OrderListParent;
